let messageApi = null

export const setMessageApi = (api) => {
  messageApi = api || null
}

const METHODS = ['success', 'error', 'info', 'warning', 'loading', 'open', 'destroy', 'config']

const invoke = (method, args) => {
  if (messageApi && typeof messageApi[method] === 'function') {
    return messageApi[method](...args)
  }
  return undefined
}

export const message = new Proxy(
  {},
  {
    get(_, method) {
      if (typeof method === 'string' && METHODS.includes(method)) {
        return (...args) => invoke(method, args)
      }
      return undefined
    },
  }
)

export default message
